cb.define([], function () {
  var ST_st_transferapplylist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      let gridModel = viewmodel.getGridModel();
	  var store =cb.rest.AppContext.user.storeId;
      gridModel.on('afterSetDataSource', () => {
        const rows = gridModel.getRows();
        const actions = gridModel.getCache('actions');
        const actionsStates = [];
        rows.forEach((data, index) => {
          const actionState = {};
          actions.forEach(action => {
            actionState[action.cItemName] = { visible: false };
						var storefirst = gridModel.getCellValue(index, "store");
						var storesecond = gridModel.getCellValue(index, "outstore");
						//调入门店为当前门店时
						if(storefirst==store){
							//保存态
							if (data.status == 0) {
								actionState["btnEdit"] = {visible:true};
								actionState["btnSubmit"] = {visible:true};
								actionState["btnDelete"] = {visible:true};
								actionState["btnStoreOut"] = {visible:false};
								actionState["btnClose"] = { visible: false};
							}
							//提交态
							else if (data.status == 1) {
								actionState["btnEdit"] = {visible:false};
								actionState["btnSubmit"] = {visible:false};
								actionState["btnDelete"] = {visible:false};
								actionState["btnStoreOut"] = {visible:false};
								actionState["btnClose"] = { visible: false};
							}
							//关闭或者出库态
							else{
								actionState["btnEdit"] = {visible:false};
								actionState["btnSubmit"] = {visible:false};
								actionState["btnDelete"] = {visible:false};
								actionState["btnStoreOut"] = {visible:false};
								actionState["btnClose"] = { visible: false};
							}
						}
						//调出门店为当前门店时
						else{
							//保存态
							if (data.status == 0) {
								actionState["btnEdit"] = {visible:false};
								actionState["btnSubmit"] = {visible:false};
								actionState["btnDelete"] = {visible:false};
								actionState["btnStoreOut"] = {visible:false};
								actionState["btnClose"] = { visible: false};
							}
							//提交态
							else if (data.status == 1) {
								actionState["btnEdit"] = {visible:false};
								actionState["btnSubmit"] = {visible:false};
								actionState["btnDelete"] = {visible:false};
								actionState["btnStoreOut"] = {visible:true};
								actionState["btnClose"] = { visible:true};
							}
							//关闭或者出库态
							else{
								actionState["btnEdit"] = {visible:false};
								actionState["btnSubmit"] = {visible:false};
								actionState["btnDelete"] = {visible:false};
								actionState["btnStoreOut"] = {visible:false};
								actionState["btnClose"] = { visible: false};
							}
						}
          });
          actionsStates.push(actionState);
        });
        gridModel.setActionsState(actionsStates);
      })
    }
  }
  try {
    module.exports = ST_st_transferapplylist_VM_Extend;
  } catch (error) {
  }
  return ST_st_transferapplylist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_transferapplylist_VM.Extend.js